import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loading } from "../../Helper/Loading";
import { patchClaim, postClaim } from "./actions";
import LabelPicture from "./components/LabelPicture";
import MetaPicture from "./components/MetaPicture";
import ResultClaim from "./components/ResultClaim";
import ValidateLabel from "./components/ValidateLabel";
import ValveStickerChoice from "./components/ValveStickerChoice";
import { post as defaultPost, VALVE_ITEM_NUMBER } from "./constants";

const params = [
  "step",
  "warranty_request",
  "a_number",
  "item_number",
  "work_date",
  "traceback",
];

export default function AddClaim() {
  const post = useSelector(state => state.addclaim.post);
  const user = useSelector(state => state.auth.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  // 🔄 Sync URL -> Redux on mount (only for first 2 steps)
  useEffect(() => {
    if (!post?.step) {
      const saved = sessionStorage.getItem("add_claim_post");
      if (saved) {
        try {
          const parsed = JSON.parse(saved);
          dispatch(patchClaim(parsed )); // or "POST"
          return;
        } catch (e) {
          console.warn("Could not parse saved claim:", e);
          sessionStorage.removeItem("add_claim_post");
        }
      }
    }
    const allowedSteps = ["label_ocr", "validate_label"];
    const stepFromUrl = searchParams.get("step");

    if (!allowedSteps.includes(stepFromUrl)) return;

    const payload = params.reduce((acc, param) => {
      const value = searchParams.get(param);
      if (value && post[param] !== value) {
        acc[param] = value;
      }
      return acc;
    }, {});

    if (Object.keys(payload).length > 0) {
      dispatch(patchClaim(payload));
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // ✅ Sync Redux -> URL
  useEffect(() => {
    if (post?.step === "finished" || post?.step === "home") {
      sessionStorage.removeItem("add_claim_post");
      dispatch(postClaim(defaultPost));
      navigate("/");
      return;
    }

    sessionStorage.setItem("add_claim_post", JSON.stringify(post));


    setSearchParams(prev => {
      const newParams = new URLSearchParams(prev);
      params.forEach(param => {
        if (post[param]) {
          newParams.set(param, post[param]);
        } else {
          newParams.delete(param);
        }
      });
      return newParams;
    }, { replace: true });


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [post?.step, post?.warranty_request, post?.a_number, post?.item_number, post?.work_date, post?.traceback]);

  if (!user?.center) {
    return <Loading />
  }


  const theStep = post?.step || "label_ocr";
  const needsValveStickerChoice =
    post?.item_number === VALVE_ITEM_NUMBER &&
    !post?.valve_sticker_variant &&
    theStep === "meta_ocr_0";

  // 🧩 Render step
  if (theStep === "label_ocr") return <LabelPicture />;
  if (theStep === "validate_label") return <ValidateLabel />;
  if (needsValveStickerChoice) return <ValveStickerChoice />;
  if (/^meta_ocr_\d{1,3}$/.test(theStep)) return <MetaPicture />;
  if (theStep === "validate_meta") return <ResultClaim />;

  return null;
}
